import MChatR from '../views/MChatR.vue'

export const routes = [
    {
      path: '/m-chat-r',
      name: 'MChatR',
      component: MChatR,
      meta: { isPublic: true }
    }
  ]